<mat-card class="mibi-profile-card">
    <mat-card-title class="mibi-profile-card__title">
        {{ strings.boxTitle }}
    </mat-card-title>
    <mat-card-content>
        <mat-checkbox
            color="primary"
            class="mibi-email-settings__checkbox"
            [checked]="settings.enabled"
            (change)="onEnabledToggle($event)"
        >
            {{ strings.enableCheckboxLabel }}
        </mat-checkbox>

        <div *ngIf="settings.enabled" class="mibi-email-settings__options">
            <!-- The frequency options are deliberately not wrapped in a
                 mat-radio-group: a group claims every descendant radio button,
                 which would rename and uncheck the weekday/week-of-month radios
                 nested below. They are grouped natively via the shared name. -->
            <ng-container *ngFor="let frequency of strings.frequencies">
                <mat-radio-button
                    color="primary"
                    name="mibi-email-frequency"
                    [value]="frequency.value"
                    [checked]="settings.frequency === frequency.value"
                    (change)="onFrequencyChange($event)"
                >
                    {{ frequency.label }}
                </mat-radio-button>

                <ng-container *ngIf="settings.frequency === frequency.value">
                    <div
                        *ngIf="frequency.value === 'weekly'"
                        class="mibi-email-settings__suboption"
                    >
                        <mat-radio-group
                            class="mibi-email-settings__inline-group"
                            [value]="settings.weekday"
                            (change)="onWeekdayChange($event)"
                        >
                            <mat-radio-button
                                *ngFor="let weekday of strings.weekdays"
                                color="primary"
                                [value]="weekday.value"
                            >
                                {{ weekday.label }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div
                        *ngIf="frequency.value === 'monthly'"
                        class="mibi-email-settings__suboption"
                    >
                        <mat-radio-group
                            class="mibi-email-settings__inline-group"
                            [value]="settings.weekOfMonth"
                            (change)="onWeekOfMonthChange($event)"
                        >
                            <mat-radio-button
                                *ngFor="let week of strings.weeksOfMonth"
                                color="primary"
                                [value]="week.value"
                            >
                                {{ week.label }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group
                            class="mibi-email-settings__inline-group"
                            [value]="settings.weekday"
                            (change)="onWeekdayChange($event)"
                        >
                            <mat-radio-button
                                *ngFor="let weekday of strings.weekdays"
                                color="primary"
                                [value]="weekday.value"
                            >
                                {{ weekday.label }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </mat-card-content>
</mat-card>
